import React from "react";

interface CustomerCareExpenseDCCMData { actualExpense: string; budget: string; percentOfBudget: string; bonusPercentEarned: string; bonusValue: string; score: string; }
interface CustomerCareExpenseDCCMSubFormProps {
  data: CustomerCareExpenseDCCMData; isEditable: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const CustomerCareExpenseDCCMSubForm: React.FC<CustomerCareExpenseDCCMSubFormProps> = ({ data, isEditable, onInputChange }) => {
  const fmt = (v: string) => v && v !== "0" && !isNaN(parseFloat(v)) ? parseFloat(v).toLocaleString() : "";
  return (
    <div className="sf-section">
      <h3 className="sf-title">Customer Care Expense (30% of total achievement score)</h3>
      <p className="sf-subtitle">This will be evaluated from monthly financial reports. The goal is meet budget.</p>
      <div className="grid grid-cols-2 gap-6">
        <div className="space-y-4">
          {[
            { label: "Actual Expense", name: "operationalEfficiency.customerCareExpense.actualExpense", value: fmt(data.actualExpense) },
            { label: "Budget",         name: "operationalEfficiency.customerCareExpense.budget",         value: fmt(data.budget) },
          ].map(f => (
            <div key={f.name}>
              <label className="sf-label">{f.label}</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: "var(--text-muted)" }}>$</span>
                <input type="text" name={f.name} value={f.value} maxLength={12} minLength={1} placeholder="0"
                  disabled={!isEditable} onChange={e => onInputChange(e, { type: "number", maxLength: 12, minLength: 1 })}
                  onFocus={e => e.target.select()} className="sf-input mt-1 block w-full pl-8 pr-3 py-2 text-right" />
              </div>
            </div>
          ))}
          <div>
            <label className="sf-label">% of Budget</label>
            <input type="text" readOnly name="operationalEfficiency.customerCareExpense.percentOfBudget"
              value={data.percentOfBudget && data.percentOfBudget !== "0" && !isNaN(Number(data.percentOfBudget)) ? (parseFloat(data.percentOfBudget) * 100).toFixed(0) : "0"}
              className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
          </div>
        </div>
      </div>
      <div className="sf-results grid grid-cols-4 gap-4">
        {[
          { label: "Bonus % Earned", name: "operationalEfficiency.customerCareExpense.bonusPercentEarned", value: data.bonusPercentEarned && !isNaN(Number(data.bonusPercentEarned)) ? parseFloat(data.bonusPercentEarned).toFixed(0) : "0" },
          { label: "30%", name: "operationalEfficiency.customerCareExpense.bonusValue", value: data.bonusValue && !isNaN(Number(data.bonusValue)) ? parseFloat(data.bonusValue).toFixed(2) : "0.30" },
          { label: "Score", name: "operationalEfficiency.customerCareExpense.score", value: data.score && !isNaN(Number(data.score)) ? parseFloat(data.score).toFixed(0) : "0" },
        ].map(f => (
          <div key={f.name}>
            <div className="sf-results-label">{f.label}</div>
            <input type="text" readOnly name={f.name} value={f.value} className="sf-input-ro mt-1 w-24 px-2 py-1 text-right" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerCareExpenseDCCMSubForm;